(function($) {
// Get Window Width and Height
var windowWidth = $(window).outerWidth();

$(document).ready(function () {
    $('.imageSlider').tSlider({
        // Main settings
        customstyle: false,
        autoplay: false,
        hoverpause: false,
        equalheight: true,
        // Navigation settings
        bullets: true,
        arrow: false,
        count: false,
        tabs: false,
        // Slide settings
        duration: 7000,
        transition: "fade",
        easing: 'easeOutCirc'
    });
    $('.topimageSlider').tSlider({
        // Main settings
        customstyle: false,
        autoplay: true,
        hoverpause: false,
        equalheight: true,
        // Navigation settings
        bullets: true,
        arrow: false,
        count: false,
        tabs: false,
        // Slide settings
        duration: 7000,
        transition: "fade",
        easing: 'easeOutCirc'
    });
    $('.widescreenSlider').tSlider({
        // Main settings
        customstyle: false,
        autoplay: false,
        hoverpause: false,
        equalheight: true,
        // Navigation settings
        bullets: false,
        arrow: true,
        count: false,
        tabs: false,
        // Slide settings
        duration: 7000,
        transition: "horizontal",
        easing: 'easeOutCirc'
    });

    //Smartphone portrait settings
    if (windowWidth < 481) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Smartphone landscape settings
    else if (windowWidth < 768) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Tablet portrait settings
    else if (windowWidth < 980) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Tablet landscape settings
    else if (windowWidth < 1025) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Screen settings
    else {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
});

$(window).resize(function () {

  // Get Window Width and Height on resize
  windowWidth = $(window).outerWidth();

    //Smartphone portrait settings
    if (windowWidth < 481) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Smartphone landscape settings
    else if (windowWidth < 768) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Tablet portrait settings
    else if (windowWidth < 980) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Tablet landscape settings
    else if (windowWidth < 1025) {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
        //Screen settings
    else {
        $('.imageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.topimageSlider').tSlider({
            swipe: true,
            transTime: 2000
        });
        $('.widescreenSlider').tSlider({
            swipe: true,
            transTime: 700
        });
    }
});

})(jQuery);
